<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="closePopover(null)">Annuler</ion-button>
      </ion-buttons>
      <ion-title>Ajouter un matériel</ion-title>
    </ion-toolbar>

    <ion-toolbar>
      <ion-searchbar
        placeholder="Rechercher ou ajouter..."
        v-model="searchQuery"
        autofocus="true"
      ></ion-searchbar>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-list>
      <ion-item
        button
        v-if="searchQuery && !isExactMatch"
        @click="closePopover(searchQuery)"
      >
        <ion-icon
          slot="start"
          :icon="addCircleOutline"
          color="success"
        ></ion-icon>

        <ion-label>
          <h2>Ajouter "{{ searchQuery }}"</h2>
          <p>Nouveau matériel</p>
        </ion-label>
      </ion-item>

      <ion-item
        button
        v-for="material in filteredMaterials"
        :key="material"
        @click="closePopover(material)"
      >
        <ion-label>{{ material }}</ion-label>
      </ion-item>

      <ion-item v-if="filteredMaterials.length === 0 && !searchQuery">
        <ion-label class="ion-text-center opacity-50">
          <p>Saisissez le nom d'un matériel</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</template>

<script>
import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonSearchbar,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
} from '@ionic/vue';
import { addCircleOutline } from 'ionicons/icons';

export default {
  name: 'PopoverAddMaterial',
  components: {
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonSearchbar,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
  },
  props: ['closePopover', 'suggestions'],

  setup() {
    return {
      addCircleOutline,
    };
  },

  data() {
    return {
      searchQuery: '',
    };
  },

  computed: {
    filteredMaterials() {
      const query = this.searchQuery.toLowerCase().trim();

      if (!this.suggestions || !this.suggestions.length) return [];
      if (!query) return this.suggestions;

      return this.suggestions.filter(m => m.toLowerCase().includes(query));
    },

    isExactMatch() {
      if (!this.searchQuery) return true;

      // return false to allow user to create new material we don't have any suggestions in the list
      if (!this.suggestions || !this.suggestions.length) return false;

      const query = this.searchQuery.toLowerCase().trim();
      return this.suggestions.some(m => m.toLowerCase() === query);
    },
  },
};
</script>
